'use strict';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { tr, lang } from '../../utils/helpers';

const $buttonTabs = $('.js-button-tabs');
const $inviteModal = $('.js-invite-modal');
const $inviteEmail = $('.js-invite-email');
const $participantsList = $('.js-participants-list');
const $participantsSearch = $('.js-participants-search');
const $closed_mission = document.querySelectorAll('[data-warning]');

const myUnity = {
  init() {
    // Button Tabs
    $buttonTabs.on('click', '.o-btn', function (e) {
      e.preventDefault();

      const $this = $(this);
      const tab = $this.attr('href');

      $this.addClass('is-active').siblings().removeClass('is-active');
      $(tab).addClass('is-active').siblings().removeClass('is-active');
    });
  },

  search() {
    // Filter Participants
    // Function to debounce a function execution
    function debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    // Function to handle participant search
    const handleParticipantSearch = debounce(function () {
      const value = $participantsSearch.val().toLowerCase();
      const $participantNames = $('.c-participants__name', $participantsList);
      const noParticipants = '<div class="c-participants__info">Nenhum participante encontrado.</div>';

      $participantNames.each(function () {
        const $this = $(this);
        const $avatar = $this.prev('.c-participants__avatar');
        const $email = $this.next('.c-participants__email');

        if ($this.text().toLowerCase().indexOf(value) > -1) {
          $this.show();
          $avatar.show();
          $email.show();
        } else {
          $this.hide();
          $avatar.hide();
          $email.hide();
        }
      });

      $('.c-participants__info').remove();

      if ($participantsList.find('.c-participants__name:visible').length === 0) {
        $participantsList.append(noParticipants);
      }
    }, 400); // Adjust the delay time as needed (in milliseconds)

    // Attach debounced handler to keyup event
    $participantsSearch.on('keyup search', handleParticipantSearch);
  },

  // Invite Friends
  modalInvite() {
    $('.js-invite-btn').on('click', function (e) {
      e.preventDefault();
      $inviteModal.addClass('is-active');
    });

    $('.js-invite-cancel').on('click', function (e) {
      e.preventDefault();
      $inviteModal.removeClass('is-active');
    });

    $('#form-invite').on('submit', function (e) {
      e.preventDefault();

      const url = $(this).attr('action');
      const email = $inviteEmail.val();
      const _token = $('meta[name="csrf-token"]').attr('content');
      let template;

      if (location.pathname.includes('/minha-unidade/desafio-relampago-1')) {
        template = `
        <img width="45" height="45" class="c-participants__avatar" src="/images/icons/user-default.png" alt="Nome do Participante">
        <div class="c-participants__name">
        ${email}
        </div>
        <div class="c-participants__email">
          Não
        </div>`;
      } else {
        template = `
        <img width="45" height="45" class="c-participants__avatar" src="/images/icons/user-default.png" alt="Nome do Participante">
        <div class="c-participants__name">
          ${tr[lang].text_invite_sent}
        </div>
        <div class="c-participants__email">
          ${email}
        </div>`;
      }

      $.ajax({
        url,
        type: 'POST',
        data: {
          email,
          _token,
          ...(window.location.pathname.includes('/minha-unidade/desafio-relampago-1') ? { lightning: true } : {}), // se a página for do desafio relâmpago, envia o parâmetro lightning
        },
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            Swal.fire(tr[lang].modal_success_invite, tr[lang].modal_success_invitemsg, 'success').then(() => {
              $(template).insertAfter('.js-participants-header');
            });
          } else {
            Swal.fire(tr[lang].modal_error_attention, data.message, 'warning');
          }
        },
        error: function (xhr, status, error) {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_invite, 'warning');
          console.error('AJAX request failed:', status, error);
        },
        complete: function () {
          $inviteModal.removeClass('is-active');
          $inviteEmail.val('');
        },
      });
    });
  },
  // Abre Modal "em breve" para as missões que estão desativadas
  closedMission() {
    $closed_mission.forEach(el => {
      el.addEventListener('click', ev => {
        ev.preventDefault();
        Swal.fire(tr[lang].modal_warning_soon, '', 'warning');
      });
    });
  },
};

export default myUnity;
